import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Home, Compass, CalendarDays, CloudSun, LayoutGrid } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

const LABELS = {
  es: { home: 'Inicio', explore: 'Explora', events: 'Eventos', weather: 'Tiempo', more: 'Más' },
  en: { home: 'Home', explore: 'Explore', events: 'Events', weather: 'Weather', more: 'More' },
  de: { home: 'Start', explore: 'Entdecken', events: 'Veranstaltungen', weather: 'Wetter', more: 'Mehr' },
};

const BottomNav = () => {
  const { language } = useLanguage();
  const t = LABELS[language] || LABELS.es;
  const { pathname } = useLocation();

  const navItems = [
    { path: '/', icon: Home, label: t.home, exact: true, id: 'home' },
    { path: '/explore', icon: Compass, label: t.explore, id: 'explore' },
    { path: '/events', icon: CalendarDays, label: t.events, id: 'events' },
    { path: '/weather', icon: CloudSun, label: t.weather, id: 'weather' },
    { path: '/more', icon: LayoutGrid, label: t.more, id: 'more' },
  ];

  return (
    <nav
      className="fixed left-3 right-3 z-50 pointer-events-none"
      style={{ bottom: 'calc(env(safe-area-inset-bottom, 0px) + 10px)', transform: 'translateZ(0)', WebkitTransform: 'translateZ(0)' }}
      data-testid="bottom-nav"
    >
      <div className="pointer-events-auto mx-auto max-w-md bg-white rounded-full shadow-[0_8px_30px_rgba(0,0,0,0.14)] border border-gray-100 px-2 py-1.5 flex justify-between items-center">
        {navItems.map(({ path, icon: Icon, label, exact, id }) => (
          <NavLink
            key={path}
            to={path}
            end={exact}
            className={({ isActive }) => {
              const active = isActive || (id === 'more' && pathname.startsWith('/info')) || (id === 'explore' && (pathname.startsWith('/trails') || pathname.startsWith('/map')));
              return `flex flex-col items-center justify-center gap-0.5 min-w-[56px] min-h-[52px] px-2 py-1.5 rounded-2xl transition-colors ${
                active ? 'bg-[#38B2AC]/12 text-[#005A63]' : 'text-gray-500 hover:text-gray-800'
              }`;
            }}
            data-testid={`nav-${id}`}
          >
            {({ isActive }) => {
              const active = isActive || (id === 'more' && pathname.startsWith('/info')) || (id === 'explore' && (pathname.startsWith('/trails') || pathname.startsWith('/map')));
              return (
                <>
                  <Icon size={24} strokeWidth={active ? 2.4 : 2} />
                  <span className={`${label.length > 10 ? 'text-[9px] tracking-tight' : 'text-[11px]'} leading-none max-w-full truncate ${active ? 'font-bold' : 'font-medium'}`}>{label}</span>
                </>
              );
            }}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default BottomNav;
